import React from "react";
import { Board } from "./components";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import "./styles.scss";

function CompanyTasks() {
  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const selectedCompany = useSelector(
    (state) => state.CompanyReducer.selected_company
  );

  // CONST VALS
  const history = useHistory();

  // HANDLERS
  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="company-tasks-wrapper">
      <h2 className="page-title">
        <button className="back-btn" onClick={goBack}>
          <ArrowLeftOutlined />
        </button>
        {selectedCompany?.company_name} Tasks Summary
      </h2>
      <Board />
    </div>
  );
}

export default CompanyTasks;
